import { makeStyles } from "@material-ui/core";

export const useBonusActionsStyle = makeStyles(() => ({
  button: {
    margin: 5,
  }
}));
